import { RootPaths } from "../App/paths";

export const DEBUG_PATH = "debug";

export const DEBUG_BASE_PATH = `${RootPaths.APP_V2_HOME}/${DEBUG_PATH}`;
